export enum ErrorTypes {
  RequestError = 'RequestError',
  GenericError = 'GenericError',
  ValidationError = 'ValidationError',
  PartnerError = 'PartnerError',
  EmailAddressInUse = 'EmailAddressInUse',
}
